var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62402 7.50513C2.62402 4.72007 4.88999 2.4541 7.67505 2.4541C10.4601 2.4541 12.7261 4.72007 12.7261 7.50513C12.7261 10.2902 10.4601 12.5562 7.67505 12.5562C4.88999 12.5562 2.62402 10.2902 2.62402 7.50513ZM16.4309 13.5134L13.7989 10.8814C14.3518 9.88011 14.6689 8.72964 14.6689 7.50496C14.6689 3.64248 11.5376 0.51123 7.67513 0.51123C3.81265 0.51123 0.681396 3.64248 0.681396 7.50496C0.681396 11.3674 3.81265 14.4987 7.67513 14.4987C8.89981 14.4987 10.0503 14.182 11.0512 13.6288L13.6835 16.2611C14.4423 17.0195 15.6725 17.0195 16.4309 16.2611C17.1897 15.5023 17.1897 14.2722 16.4309 13.5134Z",
    fill: "#25313D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.40a4ab8804e8904a5f2332384e1a6f91.svg";
export { ForwardRef as ReactComponent };